export function news() {
    function loadMore() {
        const formData  = new FormData();

        document.querySelectorAll('.js-card').forEach($item => {
            formData.append('exclude_ids[]', $item.dataset.id);
        });

        fetch(location.href, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
        .then(response => response.json())
        .then(r => {
            const $cards    = document.querySelector('.js-cards');
            const $loadMore = document.querySelector('.js-loadMore');

            if (r.status === 'ok') {
                $cards.innerHTML += r.render;

                $loadMore.classList.toggle('is-hidden', r.count <= $loadMore.dataset.limit);
            }
        });
    }

    document.addEventListener('click', function(e) {
        const $item = e.target;

        if ($item.classList.contains('js-loadMore')) {
            return loadMore();
        }
    });
}
